import Header from "./components/Header";
import Hero from "./components/Hero";
import HotFeatured from "./components/HotFeatured";
import Timeline from "./components/Timeline";
import Archive from "./components/Archive";
import Feature from "./components/Feature";
import Faq from "./components/Faq";
import Subscribe from "./components/Subscribe";
import Footer from "./components/Footer";

const TICKER = [
  "旧料翻旧账 · 2016 解约风波完整时间线出炉",
  "热点复盘 · 被重新提起的国民CP往事",
  "周年特辑 · 直播爆火三周年考古",
  "新档上架 · 饭圈大战旧料合集已更新",
  "编辑部新稿 · 塌房复盘特稿全文发布",
];

function Ticker() {
  const items = [...TICKER, ...TICKER];
  return (
    <div className="w-full overflow-hidden border-y border-background-300/60 bg-background-50 py-2.5">
      <div className="ticker-track flex w-max items-center gap-10 whitespace-nowrap">
        {items.map((t, i) => (
          <a key={i} href="#timeline" className="flex items-center gap-2 text-xs text-foreground-600 hover:text-accent-600">
            <span className="text-accent-500">
              <i className="ri-megaphone-line" />
            </span>
            {t}
          </a>
        ))}
      </div>
    </div>
  );
}

export default function Home() {
  return (
    <>
      <Header />
      <main>
        <Hero />
        <Ticker />
        <HotFeatured />
        <Timeline />
        <Archive />
        <Feature />
        <Faq />
        <Subscribe />
      </main>
      <Footer />
    </>
  );
}